import { type TabItem } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import {
    InfoTabIcon,
    SecurityNotificationTabIcon,
    VulnerabilitiesTabIcon,
} from '@components/_atoms/icons';
import TabbedInfoCard from '@components/_molecules/InfoCards/TabbedInfoCard';
import { type ComponentProps } from '../models/ComponentProps';
import { ComponentDetailsTab } from './components/ComponentDetailsTab';
import { NotificationsDetailsTab } from './components/NotificationsDetailsTab';
import { VulnerabilitiesTab } from './components/VulnerabilitiesTab';

export function ComponentInfoCard({ component }: ComponentProps): ReactNode {
    const tabItems: TabItem[] = [
        {
            name: 'Details',
            icon: <InfoTabIcon />,
            content: <ComponentDetailsTab component={component} />,
        },
        {
            name: 'Notifications',
            icon: <SecurityNotificationTabIcon />,
            content: <NotificationsDetailsTab component={component} />,
        },
        // {
        //     name: 'Vulnerabilities',
        //     icon: <VulnerabilitiesTabIcon />,
        //     content: <VulnerabilitiesTab component={component} />,
        // },
    ];

    return <TabbedInfoCard tabItems={tabItems} />;
}
